export default __webpack_public_path__ + "static/media/1718 knife block B top.300378cb.png";